<template>
  <transition name="fade" appear>
    <div
      v-if="active"
      class="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-[1px] backdrop-brightness-50"
    >
      <div
        class="mx-4 w-full max-w-md rounded-xl bg-white p-6 shadow-xl dark:bg-dark-1"
      >
        <header class="mb-2 text-xl font-bold">Firmware-Update</header>
        <QToolFirmwareUpdateScreen
          :state="state"
          :dismissing="dismissing"
          @start="emit('start')"
          @dismiss="emit('dismiss')"
        />
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import QToolFirmwareUpdateScreen from '@/components/QTool/QToolFirmwareUpdateScreen.vue';
import type { FirmwareUpdatePhase } from '@/composables/useQToolFirmwareUpdate';

defineProps<{
  active: boolean;
  state: FirmwareUpdatePhase;
  dismissing?: boolean;
}>();

const emit = defineEmits<{
  start: [];
  dismiss: [];
}>();
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
